// Copyright (c) 2025 DTCC and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { useScanProxyApiClient } from '../../contexts/ScanProxyApiContext';

export const useGetSpliceVersion: () => UseQueryResult<string, string> = () => {
  const scanProxyApi = useScanProxyApiClient();

  return useQuery({
    queryKey: ['getSpliceVersion', scanProxyApi],
    queryFn: async () => {
      const response = await scanProxyApi.getVersion();
      return response.version;
    },
    refetchInterval: false,
  });
};
